import { cn } from '@/shared/lib/cn';

const tintClasses = {
  sage: 'bg-sage/15 text-sage',
  amber: 'bg-amber/20 text-amber',
  navy: 'bg-navy/12 text-navy',
};

interface Props {
  icon: React.ReactNode;
  iconTint: keyof typeof tintClasses;
  label: string;
  value: string;
  muted?: boolean;
}

/** Kennzahl-Kachel des Kanäle-Reiters: verbunden, letzte Übertragung, letzte Buchung. */
export function ChannelKpiTile({ icon, iconTint, label, value, muted }: Props) {
  return (
    <div className="bg-card border-line/50 shadow-card rounded-lg border p-5">
      <div className="flex items-center gap-2">
        <span
          aria-hidden
          className={cn(
            'grid size-6 shrink-0 place-items-center rounded-md',
            tintClasses[iconTint],
          )}
        >
          {icon}
        </span>
        <span className="text-ink-soft text-[11px] font-semibold uppercase tracking-[0.12em]">
          {label}
        </span>
      </div>
      <div
        className={cn(
          'mt-3 font-serif text-[26px] font-normal tabular-nums leading-none',
          muted ? 'text-ink-faint' : 'text-ink',
        )}
      >
        {value}
      </div>
    </div>
  );
}
